import Group from 'models/Group';
import Referral from 'models/reviews/Referral';

export type CentralIntakeBranchGuidance = {
  preselected?: Group;
  assignedBranches: Group[];
};

export const assignedBranch = (referral: Referral) =>
  referral.data.assignedGroupId && referral.group?.id === referral.data.assignedGroupId ? referral.group : undefined;

const isForType = (referral: Referral, groupTypeId: string) =>
  referral.group?.groupTypeId === groupTypeId || referral.data.referredGroupTypeId === groupTypeId;

// Central intake's acceptance re-addresses the SNF's referral to the branch it named and keeps that branch as
// assignedGroupId, so the referral's group is the branch. The provider's other branches are left out by GET /groups,
// which applies the API's discharge lock for the stay (dischargeLocationEpisodeId).
export default function centralIntakeBranch(
  referrals: Referral[],
  groupTypeId?: string | null
): CentralIntakeBranchGuidance {
  if (!groupTypeId) return { assignedBranches: [] };

  const forType = referrals.filter((referral) => referral.accepted && isForType(referral, groupTypeId));
  const only = forType.length === 1 ? forType[0] : undefined;

  return {
    preselected: only ? assignedBranch(only) : undefined,
    assignedBranches: forType.map(assignedBranch).filter((branch): branch is Group => !!branch),
  };
}
